import AutomationAdmin from "./AutomationAdmin";
import { ADMIN_PATHS, isAdmin } from "./paths";

export { ADMIN_PATHS, isAdmin };

// The admin pages, opened from the side menu of the admin account.
export const ADMIN_ROUTES = [{ path: ADMIN_PATHS.AUTOMATION, component: AutomationAdmin }];
